// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialMedia_wrapper__c7IdR","button":"SocialMedia_button__aHKVS"};